module.exports = __webpack_public_path__ + "static/media/Netherlands.54b06564.png";